import React, {useEffect} from 'react';
import {withTranslation} from 'react-i18next';
import './linearScaleOptions.css';

const defaultOptions = {
  minValue: 0,
  maxValue: 5,
  minLabel: '',
  maxLabel: ''
};

export const LinearScaleOptions = ({options, onOptionsChanged, t}) => {
  const current = {...defaultOptions, ...options};

  useEffect(() => {
    onOptionsChanged({...defaultOptions, ...options});
  }, []);

  const update = change => onOptionsChanged({...current, ...change});
  const values = Array.from(
    {length: Math.max(0, current.maxValue - current.minValue + 1)},
    (_, index) => current.minValue + index
  );

  return <div className="br-survey-scale-editor">
    <div className="br-survey-scale-editor__limits">
      <label>
        <span>{t('SelectAtLeast')}</span>
        <select value={current.minValue}
          onChange={event => update({minValue: Number(event.target.value)})}>
          {[0, 1].map(value => <option key={value} value={value}>{value}</option>)}
        </select>
      </label>
      <label>
        <span>{t('SelectAtMost')}</span>
        <select value={current.maxValue}
          onChange={event => update({maxValue: Number(event.target.value)})}>
          {Array.from({length: 9}, (_, index) => index + 2).map(value =>
            <option key={value} value={value}>{value}</option>)}
        </select>
      </label>
    </div>
    <div className="br-survey-scale-editor__preview" aria-hidden="true">
      {values.map(value => <span key={value}>{value}</span>)}
    </div>
    <div className="br-survey-scale-editor__labels">
      <label>
        <span>{t('LabelOptional')} 1</span>
        <input type="text" value={current.minLabel}
          onChange={event => update({minLabel: event.target.value})} />
      </label>
      <label>
        <span>{t('LabelOptional')} 2</span>
        <input type="text" value={current.maxLabel}
          onChange={event => update({maxLabel: event.target.value})} />
      </label>
    </div>
  </div>;
};

export default withTranslation()(LinearScaleOptions);
